import { Container, Grid, Paper, Typography } from "@mui/material";
import React, { useState } from "react";
import Button from "../UI/Button";
import AlunoProfileV2 from "../Aluno/AlunoProfileV2";
import InsereCreditoPixForm from "./InsereCreditoPixForm";
import InsereCreditoCartaoCreditoForm from "./InsereCreditoCartaoCreditoForm";

const InsereCreditoContainer = () => {
  const pixMenu = "pixMenu";
  const [menuSelected, setMenuSelected] = useState(pixMenu);
  const cartaoCreditoMenu = "cartao-credito";

  const handleSelectedMenu = (menuSelectedPersist) => {
    setMenuSelected(menuSelectedPersist);
  };

  return (
    <>
      <Container sx={{ paddingTop: 2, paddingBottom: 2 }} component={Paper}>
        <Grid container spacing={2}>
          <Grid size={12}>
            <Typography variant="h6">Insere Crédito Cantina</Typography>
          </Grid>
          <Grid size={12}>
            <AlunoProfileV2 />
          </Grid>
          <Grid size={12}>
            <Typography variant="body1">Inserir Crédito por:</Typography>
          </Grid>
          <Grid size={12}>
            <Grid container direction="row" spacing={2} justifyContent="center">
              <Grid size={6}>
                <Button
                  disabled={menuSelected === pixMenu}
                  onClick={() => handleSelectedMenu(pixMenu)}
                >
                  Pix
                </Button>
              </Grid>
              <Grid size={3}>
                <Button
                  disabled={menuSelected === cartaoCreditoMenu}
                  onClick={() => handleSelectedMenu(cartaoCreditoMenu)}
                >
                  Cartão de Crédito
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <Grid size={12}>
            {menuSelected === pixMenu && <InsereCreditoPixForm />}
          </Grid>
          <Grid size={12}>
            {menuSelected === cartaoCreditoMenu && (
              <InsereCreditoCartaoCreditoForm />
            )}
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default InsereCreditoContainer;
